module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Act I")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("SCENE I. Rome. A street.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Enter FLAVIUS, MARULLUS, and certain Commoners")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FLAVIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Hence! home, you idle creatures get you home:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Is this a holiday? what! know you not,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Being mechanical, you ought not walk")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Upon a labouring day without the sign")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Of your profession? Speak, what trade art thou?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("First Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, sir, a carpenter.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MARULLUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Where is thy leather apron and thy rule?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What dost thou with thy best apparel on?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("You, sir, what trade are you?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Second Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Truly, sir, in respect of a fine workman, I am but,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("as you would say, a cobbler.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MARULLUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But what trade art thou? answer me directly.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Second Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("A trade, sir, that, I hope, I may use with a safe")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("conscience; which is, indeed, sir, a mender of bad soles.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MARULLUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What trade, thou knave? thou naughty knave, what trade?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Second Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Nay, I beseech you, sir, be not out with me: yet,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("if you be out, sir, I can mend you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MARULLUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What meanest thou by that? mend me, thou saucy fellow!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Second Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, sir, cobble you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_vm._v("FLAVIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Thou art a cobbler, art thou?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Second Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Truly, sir, all that I live by is with the awl: I")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("meddle with no tradesman’s matters, nor women’s")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("matters, but with awl. I am, indeed, sir, a surgeon")])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("to old shoes; when they are in great danger, I")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("recover them. As proper men as ever trod upon")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("neat’s leather have gone upon my handiwork.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FLAVIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But wherefore art not in thy shop today?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why dost thou lead these men about the streets?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Second Commoner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Truly, sir, to wear out their shoes, to get myself")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("into more work. But, indeed, sir, we make holiday,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("to see Caesar and to rejoice in his triumph.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MARULLUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Wherefore rejoice? What conquest brings he home?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What tributaries follow him to Rome,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To grace in captive bonds his chariot-wheels?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("You blocks, you stones, you worse than senseless things!")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("O you hard hearts, you cruel men of Rome,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Knew you not Pompey? Many a time and oft")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Have you climb’d up to walls and battlements,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To towers and windows, yea, to chimney-tops,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Your infants in your arms, and there have sat")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The livelong day, with patient expectation,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To see great Pompey pass the streets of Rome:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And when you saw his chariot but appear,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Have you not made an universal shout,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That Tiber trembled underneath her banks,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To hear the replication of your sounds")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Made in her concave shores?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And do you now put on your best attire?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And do you now cull out a holiday?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And do you now strew flowers in his way")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That comes in triumph over Pompey’s blood? Be gone!")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Run to your houses, fall upon your knees,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Pray to the gods to intermit the plague")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That needs must light on this ingratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FLAVIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Go, go, good countrymen, and, for this fault,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Assemble all the poor men of your sort;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Draw them to Tiber banks, and weep your tears")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Into the channel, till the lowest stream")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Do kiss the most exalted shores of all.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exeunt all the Commoners")])])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("See whether their basest metal be not moved;")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("They vanish tongue-tied in their guiltiness.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Go you down that way towards the Capitol;")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("This way will I")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("disrobe the images,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("If you do find them deck’d with ceremonies.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MARULLUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("May we do so?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("You know it is the feast of Lupercal.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FLAVIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("It is no matter; let no images")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Be hung with Caesar’s trophies. I’ll about,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And drive away the vulgar from the streets:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("So do you too, where you perceive them thick.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("These growing feathers pluck’d from Caesar’s wing")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Will make him fly an ordinary pitch,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Who else would soar above the view of men")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And keep us all in servile fearfulness.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exeunt")])])]), _c('h3', {
    staticClass: "sub-titlea"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("SCENE II. A public place.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flourish. Enter CAESAR; ANTONY, for the course; CALPURNIA, PORTIA, DECIUS BRUTUS, CICERO, BRUTUS, CASSIUS, and CASCA; a great crowd following among them a Soothsayer")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Calpurnia!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Peace, ho! Caesar speaks.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Calpurnia!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CALPURNIA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Here, my lord.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Stand you directly in Antonius’ way,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("When he doth run his course. Antonius!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ANTONY")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Caesar, my lord?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Forget not, in your speed, Antonius,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To touch Calpurnia; for our elders say,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The barren, touched in this holy chase,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Shake off their sterile curse.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ANTONY")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I shall remember:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("When Caesar says ‘do this,’ it is perform’d.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Set on; and leave no ceremony out.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flourish")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Soothsayer")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Caesar!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Ha! who calls?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Bid every noise be still: peace yet again!")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Who is it in the press that calls on me?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I hear a tongue, shriller than all the music,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Cry ‘Caesar!’ Speak; Caesar is turn’d to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Soothsayer")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Beware the ides of March.")])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("CAESAR")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("What man is that?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("A soothsayer bids you beware the ides of March.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Set him before me; let me see his face.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Fellow, come from the throng; look upon Caesar.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What say’st thou to me now? speak once again.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("Soothsayer")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Beware the ides of March.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("He is a dreamer; let us leave him: pass.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sennet. Exeunt all except BRUTUS and CASSIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Will you go see the order of the course?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Not I.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I pray you, do.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I am not gamesome: I do lack some part")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Of that quick spirit that is in Antony.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Let me not hinder, Cassius, your desires;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I’ll leave you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Brutus, I do observe you now of late:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I have not from your eyes that gentleness")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And show of love as I was wont to have:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("You bear too stubborn and too strange a hand")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Over your friend that loves you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Cassius,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Be not deceived: if I have veil’d my look,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I turn the trouble of my countenance")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Merely upon myself. Vexed I am")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Of late with passions of some difference,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Conceptions only proper to myself,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Which give some soil perhaps to my behaviors;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But let not therefore my good friends be grieved—")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Among which number, Cassius, be you one—")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Nor construe any further my neglect,")])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Than that poor Brutus, with himself at war,")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("Forgets the shows of love to other men.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Then, Brutus, I have much mistook your passion;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("By means whereof this breast of mine hath buried")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Thoughts of great value, worthy cogitations.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Tell me, good Brutus, can you see your face?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("No, Cassius; for the eye sees not itself,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But by reflection, by some other things.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("’Tis just:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And it is very much lamented, Brutus,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That you have no such mirrors as will turn")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Your hidden worthiness into your eye,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That you might see your shadow. I have heard,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Where many of the best respect in Rome,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Except immortal Caesar, speaking of Brutus")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And groaning underneath this age’s yoke,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Have wish’d that noble Brutus had his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Into what dangers would you lead me, Cassius,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That you would have me seek into myself")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For that which is not in me?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Therefore, good Brutus, be prepared to hear:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And since you know you cannot see yourself")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("So well as by reflection, I, your glass,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Will modestly discover to yourself")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That of yourself which you yet know not of.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And be not jealous on me, gentle Brutus:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Were I a common laugher, or did use")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To stale with ordinary oaths my love")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To every new protester; if you know")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That I do fawn on men and hug them hard")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And after scandal them, or if you know")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That I profess myself in banqueting")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To all the rout, then hold me dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flourish, and shout")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What means this shouting? I do fear, the people")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Choose Caesar for their king.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("CASSIUS")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("Ay, do you fear it?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Then must I think you would not have it so.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I would not, Cassius; yet I love him well.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("But wherefore do you hold me here so long?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("What is it that you would impart to me?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("If it be aught toward the general good,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Set honour in one eye and death i’ the other,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And I will look on both indifferently,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("For let the gods so speed me as I love")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The name of honour more than I fear death.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I know that virtue to be in you, Brutus,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("As well as I do know your outward favour.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Well, honour is the subject of my story.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I cannot tell what you and other men")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Think of this life; but, for my single self,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I had as lief not be as live to be")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("In awe of such a thing as I myself.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I was born free as Caesar; so were you:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("We both have fed as well, and we can both")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Endure the winter’s cold as well as he:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("For once, upon a raw and gusty day,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("The troubled Tiber chafing with her shores,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Caesar said to me ‘Darest thou, Cassius, now")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Leap in with me into this angry flood,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And swim to yonder point?’ Upon the word,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Accoutred as I was, I plunged in")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And bade him follow; so indeed he did.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("The torrent roar’d, and we did buffet it")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("With lusty sinews, throwing it aside")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And stemming it with hearts of controversy;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("But ere we could arrive the point proposed,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Caesar cried ‘Help me, Cassius, or I sink!’")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I, as Aeneas, our great ancestor,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Did from the flames of Troy upon his shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("The old Anchises bear, so from the waves of Tiber")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Did I the tired Caesar. And this man")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Is now become a god, and Cassius is")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("A wretched creature and must bend his body,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("If Caesar carelessly but nod on him.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("He had a fever when he was in Spain,")])]), _c('p', {
    staticClass: "poemi"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("And when the fit was on him, I did mark")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "poemi"
  }, [_vm._v("How he did shake: ’tis true, this god did shake;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("His coward lips did from their colour fly,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And that same eye whose bend doth awe the world")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Did lose his lustre: I did hear him groan:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Ay, and that tongue of his that bade the Romans")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Mark him and write his speeches in their books,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Alas, it cried ‘Give me some drink, Titinius,’")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("As a sick girl. Ye gods, it doth amaze me")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("A man of such a feeble temper should")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("So get the start of the majestic world")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And bear the palm alone.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Shout. Flourish")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Another general shout!")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I do believe that these applauses are")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("For some new honours that are heap’d on Caesar.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, man, he doth bestride the narrow world")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Like a Colossus, and we petty men")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Walk under his huge legs and peep about")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("To find ourselves dishonourable graves.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Men at some time are masters of their fates:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("The fault, dear Brutus, is not in our stars,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("But in ourselves, that we are underlings.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Brutus and Caesar: what should be in that ‘Caesar’?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Why should that name be sounded more than yours?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Write them together, yours is as fair a name;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Sound them, it doth become the mouth as well;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Weigh them, it is as heavy; conjure with ’em,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Brutus will start a spirit as soon as Caesar.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Now, in the names of all the gods at once,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Upon what meat doth this our Caesar feed,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("That he is grown so great? Age, thou art shamed!")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Rome, thou hast lost the breed of noble bloods!")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("When went there by an age, since the great flood,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("But it was famed with more than with one man?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("When could they say till now, that talk’d of Rome,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("That her wide walls encompass’d but one man?")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Now is it Rome indeed and room enough,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("When there is in it but one only man.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("O, you and I have heard our fathers say,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("There was a Brutus once that would have brook’d")])]), _c('p', {
    staticClass: "poemi"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The eternal devil to keep his state in Rome")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "poemi"
  }, [_vm._v("As easily as a king.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That you do love me, I am nothing jealous;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("What you would work me to, I have some aim:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("How I have thought of this and of these times,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I shall recount hereafter; for this present,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I would not, so with love I might entreat you,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Be any further moved. What you have said")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I will consider; what you have to say")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I will with patience hear, and find a time")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Both meet to hear and answer such high things.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Till then, my noble friend, chew upon this:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Brutus had rather be a villager")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Than to repute himself a son of Rome")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Under these hard conditions as this time")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Is like to lay upon us.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I am glad that my weak words")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Have struck but thus much show of fire from Brutus.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The games are done and Caesar is returning.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("As they pass by, pluck Casca by the sleeve;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And he will, after his sour fashion, tell you")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("What hath proceeded worthy note to-day.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Re-enter CAESAR and his Train")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I will do so. But, look you, Cassius,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("The angry spot doth glow on Caesar’s brow,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And all the rest look like a chidden train:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Calpurnia’s cheek is pale; and Cicero")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Looks with such ferret and such fiery eyes")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("As we have seen him in the Capitol,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Being cross’d in conference by some senators.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Casca will tell us what the matter is.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Antonius!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ANTONY")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Caesar?")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("CAESAR")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("Let me have men about me that are fat;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Sleek-headed men and such as sleep o’ nights:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Yond Cassius has a lean and hungry look;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("He thinks too much: such men are dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ANTONY")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Fear him not, Caesar; he’s not dangerous;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("He is a noble Roman and well given.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CAESAR")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Would he were fatter! But I fear him not:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Yet if my name were liable to fear,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I do not know the man I should avoid")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("So soon as that spare Cassius. He reads much;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("He is a great observer and he looks")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Quite through the deeds of men: he loves no plays,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("As thou dost, Antony; he hears no music;")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Seldom he smiles, and smiles in such a sort")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("As if he mock’d himself and scorn’d his spirit")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("That could be moved to smile at any thing.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Such men as he be never at heart’s ease")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Whiles they behold a greater than themselves,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And therefore are they very dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("I rather tell thee what is to be fear’d")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Than what I fear; for always I am Caesar.")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Come on my right hand, for this ear is deaf,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And tell me truly what thou think’st of him.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sennet. Exeunt CAESAR and all his Train, but CASCA")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("You pull’d me by the cloak; would you speak with me?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Ay, Casca; tell us what hath chanced to-day,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("That Caesar looks so sad.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, you were with him, were you not?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I should not then ask Casca what had chanced.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, there was a crown offered him: and being")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("offered him, he put it by with the back of his hand,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("thus; and then the people fell a-shouting.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What was the second noise for?")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("CASCA")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, for that too.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("They shouted thrice: what was the last cry for?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, for that too.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Was the crown offered him thrice?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Ay, marry, was’t, and he put it by thrice, every")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("time gentler than other, and at every putting-by")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("mine honest neighbours shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Who offered him the crown?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why, Antony.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Tell us the manner of it, gentle Casca.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I can as well be hanged as tell the manner of it:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("it was mere foolery; I did not mark it. I saw Mark")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Antony offer him a crown;—yet ’twas not a crown")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("neither, ’twas one of these coronets;—and, as I told")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("you, he put it by once: but, for all that, to my")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("thinking, he would fain have had it. Then he")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("offered it to him again; then he put it by again:")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("but, to my thinking, he was very loath to lay his")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("fingers off it. And then he offered it the third")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("time; he put it the third time by: and still as he")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("refused it, the rabblement hooted and clapped their")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("chapped hands and threw up their sweaty night-caps")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("and uttered such a deal of stinking breath because")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Caesar refused the crown that it had almost choked")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("Caesar; for he swounded and fell down at it: and")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("for mine own part, I durst not laugh, for fear of")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("opening my lips and receiving the bad air.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But, soft, I pray you: what, did Caesar swound?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("He fell down in the market-place, and foamed at")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("mouth, and was speechless.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("’Tis very like: he hath the failing sickness.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("CASSIUS")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("No, Caesar hath it not; but you and I,")]), _vm._v(" "), _c('p', {
    staticClass: "poemi"
  }, [_vm._v("And honest Casca, we have the falling sickness.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("I know not what you mean by that; but, I am sure,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Caesar fell down. If the tag-rag people did not")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("clap him and hiss him, according as he pleased and")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("displeased them, as they use to do the players in")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("the theatre, I am no true man.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What said he when he came unto himself?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Marry, before he fell down, when he perceived the")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("common herd was glad he refused the crown, he")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("plucked me ope his doublet and offered them his")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("throat to cut. An I had been a man of any")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("occupation, if I would not have taken him at a word,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I would I might go to hell among the rogues. And so")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("he fell. When he came to himself again, he said,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("If he had done or said any thing amiss, he desired")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("their worships to think it was his infirmity. Three")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("or four wenches, where I stood, cried ‘Alas, good")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("soul!’ and forgave him with all their hearts: but")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("there’s no heed to be taken of them; if Caesar had")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("stabbed their mothers, they would have done no less.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And after that, he came, thus sad, away?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Ay.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Did Cicero say any thing?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Ay, he spoke Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To what effect?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Nay, an I tell you that, Ill ne’er look you i’ the")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("face again: but those that understood him smiled at")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("one another and shook their heads; but, for mine own")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("part, it was Greek to me. I could tell you more")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("news too: Marullus and Flavius, for pulling scarfs")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("off Caesar’s images, are put to silence. Fare you")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("well. There was more foolery yet, if I could")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("remember it.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("CASSIUS")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "poema1"
  }, [_vm._v("Will you sup with me to-night, Casca?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("No, I am promised forth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Will you dine with me to-morrow?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Ay, if I be alive and your mind hold and your dinner")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("worth the eating.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Good: I will expect you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Do so. Farewell, both.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exit")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("What a blunt fellow is this grown to be!")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("He was quick mettle when he went to school.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("So is he now in execution")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Of any bold or noble enterprise,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("However he puts on this tardy form.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("This rudeness is a sauce to his good wit,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Which gives men stomach to digest his words")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("With better appetite.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BRUTUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("And so it is. For this time I will leave you:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To-morrow, if you please to speak with me,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I will come home to you; or, if you will,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Come home to me, and I will wait for you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("I will do so: till then, think of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exit BRUTUS")])]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Well, Brutus, thou art noble; yet, I see,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Thy honourable metal may be wrought")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("From that it is disposed: therefore it is meet")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That noble minds keep ever with their likes;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For who so firm that cannot be seduced?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Caesar doth bear me hard; but he loves Brutus:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("If I were Brutus now and he were Cassius,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("He should not humour me. I will this night,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("In several hands, in at his windows throw,")])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("As if they came from several citizens,")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("Writings all tending to the great opinion")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That Rome holds of his name; wherein obscurely")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Caesar’s ambition shall be glanced at:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And after this let Caesar seat him sure;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For we will shake him, or worse days endure.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exit")])])]), _c('h3', {
    staticClass: "sub-titlea"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("SCENE III. The same. A street.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thunder and lightning. Enter from opposite sides, CASCA, with his sword drawn, and CICERO")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CICERO")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Good even, Casca: brought you Caesar home?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why are you breathless? and why stare you so?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Are not you moved, when all the sway of earth")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Shakes like a thing unfirm? O Cicero,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I have seen tempests, when the scolding winds")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Have rived the knotty oaks, and I have seen")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The ambitious ocean swell and rage and foam,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To be exalted with the threatening clouds:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But never till to-night, never till now,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Did I go through a tempest dropping fire.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Either there is a civil strife in heaven,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Or else the world, too saucy with the gods,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Incenses them to send destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CICERO")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Why, saw you any thing more wonderful?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("A common slave—you know him well by sight—")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Held up his left hand, which did flame and burn")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Like twenty torches join’d, and yet his hand,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Not sensible of fire, remain’d unscorch’d.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Besides—I ha’ not since put up my sword—")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Against the Capitol I met a lion,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Who glared upon me, and went surly by,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Without annoying me: and there were drawn")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Upon a heap a hundred ghastly women,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Transformed with their fear; who swore they saw")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Men all in fire walk up and down the streets.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And yesterday the bird of night did sit")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Even at noon-day upon the market-place,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Hooting and shrieking. When these prodigies")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Do so conjointly meet, let not men say")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("‘These are their reasons; they are natural;’")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For, I believe, they are portentous things")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Unto the climate that they point upon.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("CICERO")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "poema1"
  }, [_vm._v("Indeed, it is a strange-disposed time:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But men may construe things after their fashion,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Clean from the purpose of the things themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Come Caesar to the Capitol to-morrow?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("He doth; for he did bid Antonius")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Send word to you he would be there to-morrow.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CICERO")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Good night then, Casca: this disturbed sky")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Is not to walk in.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Farewell, Cicero.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exit CICERO")])]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Enter CASSIUS")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Who’s there?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("A Roman.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Casca, by your voice.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Your ear is good. Cassius, what night is this!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("A very pleasing night to honest men.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Who ever knew the heavens menace so?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Those that have known the earth so full of faults.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For my part, I have walk’d about the streets,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Submitting me unto the perilous night,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And, thus unbraced, Casca, as you see,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Have bared my bosom to the thunder-stone;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And when the cross blue lightning seem’d to open")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The breast of heaven, I did present myself")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Even in the aim and very flash of it.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("But wherefore did you so much tempt the heavens?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("It is the part of men to fear and tremble,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("When the most mighty gods by tokens send")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Such dreadful heralds to astonish us.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("CASSIUS")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "poema1"
  }, [_vm._v("You are dull, Casca, and those sparks of life")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That should be in a Roman you do want,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Or else you use not. You look pale and gaze")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And put on fear and cast yourself in wonder,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To see the strange impatience of the heavens:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But if you would consider the true cause")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why all these fires, why all these gliding ghosts,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why birds and beasts from quality and kind,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why old men fool and children calculate,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Why all these things change from their ordinance")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Their natures and preformed faculties")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To monstrous quality,—why, you shall find")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That heaven hath infused them with these spirits,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To make them instruments of fear and warning")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Unto some monstrous state.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Now could I, Casca, name to thee a man")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Most like this dreadful night,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That thunders, lightens, opens graves, and roars")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("As doth the lion in the Capitol,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("A man no mightier than thyself or me")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("In personal action, yet prodigious grown")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And fearful, as these strange eruptions are.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("’Tis Caesar that you mean; is it not, Cassius?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Let it be who it is: for Romans now")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Have thews and limbs like to their ancestors;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But, woe the while! our fathers’ minds are dead,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And we are govern’d with our mothers’ spirits;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Our yoke and sufferance show us womanish.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Indeed, they say the senators tomorrow")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Mean to establish Caesar as a king;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And he shall wear his crown by sea and land,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("In every place, save here in Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("I know where I will wear this dagger then;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Cassius from bondage will deliver Cassius:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Therein, ye gods, you make the weak most strong;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Therein, ye gods, you tyrants do defeat:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Nor stony tower, nor walls of beaten brass,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Nor airless dungeon, nor strong links of iron,")])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Can be retentive to the strength of spirit;")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("But life, being weary of these worldly bars,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Never lacks power to dismiss itself.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("If I know this, know all the world besides,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That part of tyranny that I do bear")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("I can shake off at pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Thunder still")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("So can I:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("So every bondman in his own hand bears")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("The power to cancel his captivity.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("And why should Caesar be a tyrant then?")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Poor man! I know he would not be a wolf,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But that he sees the Romans are but sheep:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("He were no lion, were not Romans hinds.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Those that with haste will make a mighty fire")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Begin it with weak straws: what trash is Rome,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("What rubbish and what offal, when it serves")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For the base matter to illuminate")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("So vile a thing as Caesar! But, O grief,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Where hast thou led me? I perhaps speak this")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Before a willing bondman; then I know")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("My answer must be made. But I am arm’d,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And dangers are to me indifferent.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("You speak to Casca, and to such a man")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("That is no fleering tell-tale. Hold, my hand:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Be factious for redress of all these griefs,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And I will set this foot of mine as far")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("As who goes farthest.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("There’s a bargain made.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Now know you, Casca, I have moved already")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Some certain of the noblest-minded Romans")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To undergo with me an enterprise")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Of honourable-dangerous consequence;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And I do know, by this, they stay for me")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("In Pompey’s porch: for now, this fearful night,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("There is no stir or walking in the streets;")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And the complexion of the element")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("In favour’s like the work we have in hand,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Most bloody, fiery, and most terrible.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("CASCA")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "poema1"
  }, [_vm._v("Stand close awhile, for here comes one in haste.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("’Tis Cinna; I do know him by his gait;")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("He is a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Enter CINNA")])]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Cinna, where haste you so?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CINNA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("To find out you. Who’s that? Metellus Cimber?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("No, it is Casca; one incorporate")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To our attempts. Am I not stay’d for, Cinna?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CINNA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("I am glad on ’t. What a fearful night is this!")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("There’s two or three of us have seen strange sights.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Am I not stay’d for? tell me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CINNA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Yes, you are.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("O Cassius, if you could")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("But win the noble Brutus to our party—")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Be you content: good Cinna, take this paper,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And look you lay it in the praetor’s chair,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Where Brutus may but find it; and throw this")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("In at his window; set this up with wax")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Upon old Brutus’ statue: all this done,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Repair to Pompey’s porch, where you shall find us.")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Is Decius Brutus and Trebonius there?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CINNA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("All but Metellus Cimber; and he’s gone")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("To seek you at your house. Well, I will hie,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And so bestow these papers as you bade me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("That done, repair to Pompey’s theatre.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exit CINNA")])]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Come, Casca, you and I will yet ere day")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("See Brutus at his house: three parts of him")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Is ours already, and the man entire")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("Upon the next encounter yields him ours.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASCA")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("O, he sits high in all the people’s hearts:")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("And that which would appear offence in us,")])]), _c('p', {
    staticClass: "poema"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("His countenance, like richest alchemy,")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "poema"
  }, [_vm._v("Will change to virtue and to worthiness.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CASSIUS")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_vm._v("Him and his worth and our great need of him")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("You have right well conceited. Let us go,")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("For it is after midnight; and ere day")]), _vm._v(" "), _c('p', {
    staticClass: "poema"
  }, [_vm._v("We will awake him and be sure of him.")]), _vm._v(" "), _c('p', {
    staticClass: "poema1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Exeunt")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4e5562","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Chapter01.vue
// module id = 69
// module chunks = 0